import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Cacheable } from '@core/helpers';
import { Observable } from 'rxjs';
import { UserEntity } from '@core/entities';
import { GetDatabaseId, GetTeamId, GetUserId } from '@core/utils';
import { CacheService } from '@core/services/misc/cache.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly _cacheService = inject(CacheService);
  private readonly _http = inject(HttpClient);
  private readonly _memberUrl = environment.memberUrl;
  private readonly _baseUrl = environment.apiUrl;

  private readonly _userId = GetUserId();
  private readonly _teamId = GetTeamId();
  private readonly _databaseId = GetDatabaseId();

  @Cacheable('getUserProfilePhoto', { ttl: 1000000, handleError: true })
  getUserProfilePhoto(memberId: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/profile-photo/${memberId}`);
    // This api call was initially directed to other backend , as this function is used on various places it not being removed but it is updated to point to the local backend.
  }

  // @Cacheable('getUserProfilePhotoLocal', { ttl: 60000, handleError: true })
  getUserProfilePhotoFromLocal(memberId: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/profile-photo/${memberId}`);
  }

  getInfo(memberId: number, teamId: number, databaseId: number): Observable<UserEntity> {
    return this._http.get<any>(`${this._baseUrl}/profile-info/${databaseId}/${teamId}/${memberId}`);
  }

  updatePassword(data: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/change-password`, data);
  }

  save(memberId: number, teamId: number, databaseId: number, data: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/modify-user-data/${databaseId}/${teamId}/${memberId}`, data);
  }

  uploadUserPhoto(data: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/change-profile-picture`, data);
  }
}
